// /admin/users CRUD-Wrapper — alle Endpoints Owner-only (siehe api/src/routes/admin.ts).

import { apiFetch } from './api';
import type { CoachingPlan, CoachingSource, CoachingStatus } from './coaching-api';

export type UserTier = 'owner' | 'pro' | 'trial' | 'free';
export type UserRole = UserTier;

export interface AdminUserRow {
  id: string;
  email: string;
  nickname: string | null;
  role: UserRole;
  tier: UserTier;
  created_at: string | null;
  trial_expires_at: string | null;
  stripe_status: string | null;
  last_seen: string | null;
  disclaimer_accepted_at: string | null;
  privacy_accepted_at: string | null;
  total_paid_cents: number;
  // Credits-Modell — aktuelle Credit-Balance des Users (Backend joint eve_credit_wallets)
  balance: number;
  // Welle 2 — Coaching (kommt aus dem Welle-2-Backend-Update von /admin/users)
  coaching_status: CoachingStatus | null;
  coaching_plan: CoachingPlan | null;
  coaching_period_end: string | null;
  coaching_source: CoachingSource | null;
  // Credits-Modell — aktives Abo (plan_id + status), Backend joint eve_subscriptions
  subscription_plan: string | null;
  subscription_status: string | null;
}

export async function listAdminUsers(accessToken: string): Promise<AdminUserRow[]> {
  return apiFetch<AdminUserRow[]>('/admin/users', { accessToken });
}

export interface PatchUserInput {
  role: UserRole;
  reason?: string;
}

export interface PatchUserResponse {
  ok: true;
  before?: string;
  after?: string;
  unchanged?: boolean;
}

export async function patchAdminUser(
  accessToken: string,
  userId: string,
  input: PatchUserInput,
): Promise<PatchUserResponse> {
  return apiFetch<PatchUserResponse>(`/admin/users/${userId}`, {
    method: 'PATCH',
    accessToken,
    json: input,
  });
}

export interface DeleteUserInput {
  reason?: string;
}

export interface DeleteUserResponse {
  ok: true;
  deleted_at: string;
}

export async function deleteAdminUser(
  accessToken: string,
  userId: string,
  input: DeleteUserInput = {},
): Promise<DeleteUserResponse> {
  return apiFetch<DeleteUserResponse>(`/admin/users/${userId}`, {
    method: 'DELETE',
    accessToken,
    json: input,
  });
}

export interface CreateUserInput {
  email: string;
  role?: UserRole;
  nickname?: string;
}

export interface CreateUserResponse {
  id: string;
  email: string;
  role: UserRole;
  invite_url: string;
  expires_at: string;
}

export async function createAdminUser(
  accessToken: string,
  input: CreateUserInput,
): Promise<CreateUserResponse> {
  return apiFetch<CreateUserResponse>('/admin/users', {
    method: 'POST',
    accessToken,
    json: input,
  });
}
